import React from 'react'

export default function Login() {
	return (
		<div className='Login flexCenter'>
			Login
		</div>
	)
}
